var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "s-orders-nav"
  }, [_c('div', {
    staticClass: "s-basis-1/4"
  }, [_c('button', {
    staticClass: "s-orders-btn ml-3 pl-3 pr-3",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")])]), _c('div', {
    staticClass: "text-center s-basis-1/2"
  }, [_vm._v("訂單明細")])]), _vm.fetching ? _c('p', [_c('Loading')], 1) : [_c('DetailSection', {
    staticClass: "m-3",
    attrs: {
      "icon": "info",
      "title": "消費資訊"
    }
  }, [_c('table', {
    staticClass: "s-text-sm s-w-full"
  }, [_vm.orderFieldSetting.length > 0 ? _vm._l(_vm.orderFieldSetting, function (field, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "s-font-semibold s-text-primary-text"
    }, [_vm._v(_vm._s(field.value))]), _c('td', {
      staticClass: "s-text-right s-text-black"
    }, [_vm._v(_vm._s(_vm.getOrderData(field.key)))])]);
  }) : [_c('tr', [_c('td', {
    staticClass: "s-font-semibold s-text-primary-text"
  }, [_vm._v("訂單編號")]), _c('td', {
    staticClass: "s-text-right s-text-black"
  }, [_vm._v(_vm._s(_vm.order.order_number))])]), _c('tr', [_c('td', {
    staticClass: "s-font-semibold s-text-primary-text"
  }, [_vm._v("訂單時間")]), _c('td', {
    staticClass: "s-text-right s-text-black"
  }, [_vm._v(_vm._s(_vm.datetime))])]), _c('tr', [_c('td', {
    staticClass: "s-font-semibold s-text-primary-text"
  }, [_vm._v("訂單金額")]), _c('td', {
    staticClass: "s-text-right s-font-semibold s-text-black"
  }, [_vm._v("NT$ " + _vm._s(_vm.$currency(_vm.order.amount, '')))])]), _c('tr', [_c('td', {
    staticClass: "s-font-semibold s-text-primary-text"
  }, [_vm._v("訂單狀態")]), _c('td', {
    staticClass: "s-text-right s-font-semibold s-text-black"
  }, [_vm._v(_vm._s(_vm.order.order_status))])]), _c('tr', [_c('td', {
    staticClass: "s-font-semibold s-text-primary-text"
  }, [_vm._v("運送狀態")]), _c('td', {
    staticClass: "s-text-right s-font-semibold s-text-black"
  }, [_vm._v(_vm._s(_vm.order.delivery_status))])])]], 2)]), _c('DetailSection', {
    staticClass: "m-3",
    attrs: {
      "icon": "list",
      "title": "消費明細"
    }
  }, [_c('table', {
    staticClass: "s-text-sm s-w-full"
  }, [_c('thead', [_c('tr', {
    staticClass: "s-font-semibold"
  }, [_vm.orderItemFieldSetting.length > 0 ? _vm._l(_vm.orderItemFieldSetting, function (field, i) {
    return _c('th', {
      key: i,
      staticClass: "text-nowrap",
      class: _vm.itemThClass(i)
    }, [_vm._v(" " + _vm._s(field.value) + " ")]);
  }) : [_c('th', {
    staticClass: "s-text-primary-text text-nowrap"
  }, [_vm._v("名稱")]), _c('th', {
    staticClass: "s-text-right s-min-w-10 s-text-black px-2 text-nowrap"
  }, [_vm._v("數量")]), _c('th', {
    staticClass: "s-text-right s-min-w-10 s-text-black text-nowrap"
  }, [_vm._v("金額")])]], 2)]), _c('tbody', _vm._l(_vm.items, function (item, i) {
    return _c('tr', {
      key: i
    }, [_vm.orderItemFieldSetting.length > 0 ? _vm._l(_vm.orderItemFieldSetting, function (field, j) {
      return _c('td', {
        key: j,
        class: _vm.itemTdClass(j)
      }, [_vm._v(" " + _vm._s(Number.isNaN(parseInt(item[field.key])) ? item[field.key] : parseInt(item[field.key]).toLocaleString('en-US')) + " ")]);
    }) : [_c('td', {
      staticClass: "s-text-primary-text"
    }, [_vm._v(_vm._s(item.name))]), _c('td', {
      staticClass: "s-text-right s-text-black px-2"
    }, [_vm._v(_vm._s(item.quantity))]), _c('td', {
      staticClass: "s-text-right s-text-black"
    }, [_vm._v(_vm._s(item.price.toLocaleString('en-US')))])]], 2);
  }), 0)])])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }